module.exports = __webpack_public_path__ + "static/media/game(29).dfaa0ebc.PNG";